import React, { memo, useState } from 'react';
import { View } from 'react-native';
import { useLocale } from '@redlink/assets/locale';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space } from '@redlink/components/atoms';
import { Button } from '@redlink/components/molecules';

export const PreviewResumeItemsGroup = memo(
  ({
    title,
    data = [],
    style,
    contentContainerStyle,
    ItemComponent,
    limit,
  }) => {
    const { styles } = useStyle();
    const { dictionary } = useLocale();
    const [isExpanded, setIsExpanded] = useState(false);

    const renderContent = (item, index) => (
      <View key={`${index}`}>
        {ItemComponent({ item })}
        <Space size={8} />
      </View>
    );

    const limitButtonIsvisible = limit > 0 && limit < data.length;

    return (
      <View {...{ style }}>
        <Text style={styles.text}>{title}</Text>
        <Space size={8} />
        <View style={contentContainerStyle}>
          {data
            .slice(0, !isExpanded ? limit : data.length)
            .map((item, index) => renderContent(item, index))}
        </View>
        {limitButtonIsvisible && (
          <View style={styles.limitButtonContainer}>
            <Button
              variant="transparent"
              title={isExpanded ? dictionary.less : dictionary.showAll}
              textStyle={styles.buttonTextStyle}
              onPress={() => setIsExpanded((prev) => !prev)}
            />
          </View>
        )}
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors }) => ({
  text: {
    fontSize: 16,
    color: colors.title,
    fontWeight: 'bold',
  },
  limitButtonContainer: {
    borderRadius: 10,
    backgroundColor: colors.cardBackground,
  },
  buttonTextStyle: {
    color: colors.primary,
  },
}));
